export const NOTIFICATION_LEVEL_INFO = "info";
export const NOTIFICATION_LEVEL_WARNING = "warning";
export const NOTIFICATION_LEVEL_DANGER = "danger";

interface SystemNotification {
  id?: number;
  type?: string;
  title?: string;
  description?: string;
  level?: string;
  source?: string;
  taxPayerId?: number;
  active?: boolean;
  startsAt?: string;
  expiresAt?: string;
  createdAt?: string;
}

export const newSystemNotification = (): SystemNotification => {
  return {};
};

export default SystemNotification;
